export default __webpack_public_path__ + "static/media/do-1.81301793.jpg";